var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEuFlag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5570_5996)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9867 21.28C16.7783 21.28 21.4734 16.585 21.4734 10.7933C21.4734 5.00169 16.7783 0.306641 10.9867 0.306641C5.19505 0.306641 0.5 5.00169 0.5 10.7933C0.5 16.585 5.19505 21.28 10.9867 21.28Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9861 4.41211L11.3256 5.45705H12.4243L11.5354 6.10284L11.875 7.14778L10.9861 6.50195L10.0972 7.14778L10.4367 6.10284L9.54785 5.45705H10.6465L10.9861 4.41211Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47333 6.28197L7.45236 6.78074L8.22924 6.00391L8.05731 7.08903L9.0363 7.58784L7.95113 7.75973L7.77925 8.84494L7.28044 7.86595L6.19531 8.03787L6.97219 7.261L6.47333 6.28197Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60352 10.7957L5.64846 10.4561V9.35742L6.29421 10.2463L7.33919 9.90678L6.69331 10.7957L7.33919 11.6845L6.29421 11.345L5.64846 12.2339V11.1352L4.60352 10.7957Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.47333 15.309L6.97215 14.33L6.19531 13.5531L7.28048 13.7251L7.77921 12.7461L7.95113 13.8313L9.03626 14.0031L8.05739 14.502L8.22924 15.5871L7.45236 14.8102L6.47333 15.309Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9861 17.1789L10.6465 16.134H9.54785L10.4368 15.4882L10.0972 14.4434L10.9861 15.0891L11.875 14.4434L11.5354 15.4882L12.4243 16.134H11.3256L10.9861 17.1789Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5004 15.309L14.5214 14.8102L13.7445 15.5871L13.9164 14.5019L12.9375 14.0031L14.0226 13.8313L14.1945 12.7461L14.6933 13.7251L15.7784 13.5531L15.0015 14.3301L15.5004 15.309Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3704 10.7957L16.3254 11.1352V12.2339L15.6796 11.345L14.6348 11.6845L15.2806 10.7957L14.6348 9.90678L15.6797 10.2463L16.3254 9.35742V10.4561L17.3704 10.7957Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5004 6.28193L15.0016 7.26096L15.7784 8.03783L14.6932 7.86587L14.1945 8.84485L14.0226 7.75969L12.9375 7.58776L13.9164 7.08899L13.7445 6.00391L14.5214 6.78074L15.5004 6.28193Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5570_5996"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.9734,
    height: 20.9734,
    fill: "white",
    transform: "translate(0.5 0.306641)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEuFlag);
export default __webpack_public_path__ + "static/media/eu-flag.2a81512167ec41095963bd0f6a06f83a.svg";
export { ForwardRef as ReactComponent };